
import EditorImage from 'Editors/EditorImage'
import EditorTipTap from 'Editors/EditorTipTap'
import EditorLink from 'Editors/EditorLink'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    EditorImage,
    // eslint-disable-next-line vue/no-unused-components
    EditorTipTap,
    // eslint-disable-next-line vue/no-unused-components
    EditorLink,
  },
  data() {
    return {
      inView: false,
      options: [
        {
          name: 'logo',
          label: 'Logo',
          type: 'image',
        },
        {
          name: 'subtitle',
          label: 'Subtitle',
          type: 'tipTap',
        },
        {
          name: 'title',
          label: 'Title',
          type: 'tipTap',
        },
        {
          name: 'description',
          label: 'Description',
          type: 'tipTap',
        },
        {
          name: 'link',
          label: 'Poveznica',
          type: 'link',
        },
      ],
    }
  },
}
